export const ApiEndpoint = process.env.API_ENDPOINT || "https://api.ikeono.local/v2/website-widget"
export const ShimHost = process.env.SHIM_HOST || "https://ik-widget.ngrok.io"
export const WidgetApiHost = process.env.WIDGET_API_HOST || "http://localhost:8888"